import { ADD_SPECIALDAY, ADD_SPECIALDAY_FAILED, ADD_SPECIALDAY_SUCCESS, SPECIALDAY, SPECIALDAY_FAILED, SPECIALDAY_SUCCESS, UPDATE_SPECIALDAY, UPDATE_SPECIALDAY_FAILED, UPDATE_SPECIALDAY_SUCCESS } from "./actionTypes"

let initialState = {
    holiday: [],
    addHoliday: "",
    updateHoliday: "",
    loading: false,
    success: false,
    error: ''
}

export const specialdayReducer = (state = initialState, action) => {
    switch (action.type) {

        case SPECIALDAY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case SPECIALDAY_SUCCESS: return {
            ...state,
            holiday: action.payload,
            loading: false,
            success: true
        }
        case SPECIALDAY_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_SPECIALDAY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_SPECIALDAY_SUCCESS: return {
            ...state,
            addHoliday: action.payload,
            holiday: [...state.holiday, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_SPECIALDAY_FAILED: return {
            ...state,
            addHoliday: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_SPECIALDAY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_SPECIALDAY_SUCCESS: return {
            ...state,
            updateHoliday: action.payload,
            holiday: state.holiday.map((item) => item.id === action.payload._id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_SPECIALDAY_FAILED: return {
            ...state,
            updateHoliday: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}